import React from "react";
import { Col, Container, Row} from "reactstrap";
import { Circle } from '../../Ui/Circles/Circle';
import classes from './Home.module.css';

const Home = props => {
  return (
    <Container>
      <Row>
        <Col className={classes.titleContainer}>
          <div>
            <h1>Bienvenidos a <div style={{color: "#0DB04B", display: 'inline-block'}}>Soy Mentor</div></h1>
            <h6>Nuestro objetivo es ser el punto de encuentro de la comunidad de Universidad Tecmilenio que permita construir relaciones positivas de mentoreo para el éxito y bienestar de sus integrantes, desarrollando las competencias necesarias para asumir los retos que se les presenten en su vida.</h6>
          </div>
        </Col>
        <Col className={classes.imagesMainContainer}>
          <div className={classes.imageContainer}>
            <img className={classes.image + " " + classes.image2} src="/images/image-2.png" title="Imagen 2" alt="image"/>
            <img className={classes.image + " " + classes.image5} src="/images/image-5.png" title="Imagen 5" alt="image"/>
            <img className={classes.image + " " + classes.image6} src="/images/image-6.png" title="Imagen 6" alt="image"/>
          </div>
          <div className={classes.imageContainer}>
            <img className={classes.image + " " + classes.image3} src="/images/image-3.png" title="Imagen 3" alt="image"/>
            <img className={classes.image + " " + classes.image4} src="/images/image-4.png" title="Imagen 4" alt="image"/>
            <img className={classes.image + " " + classes.image1} src="/images/image-1.png" title="Imagen 1" alt="image"/>
          </div>
        </Col>
      </Row>

      <Row className={classes.row}>
        <Col className={classes.colCenter}>
          <h4>Conviértete en un mentor voluntario o mentora voluntaria</h4>
          <p>Ya seas <b>colaborador, colaboradora, docente, estudiante, egresado o egresada</b> de Universidad Tecmilenio; o trabajas en una empresa con convenio, puedes cambiar la vida de cientos de estudiantes.</p>
          <a className={classes.mentorButton} href="/quiero-ser-mentor">Quiero ser mentor</a>
        </Col>
      </Row>

      <Row style={{margin: "100px 0", backgroundColor: "#F9F9FA", padding: "50px 0"}}>
        <Col className={classes.colCenter}>
          <h4>Encuentra a un mentor</h4>
          <p>Conoce el área profesional de tu interés de la mano de una persona que ya cuenta con experiencia para orientarte.</p>
        </Col>
      </Row>

      <Row className={classes.row}>
        <Col className={classes.colCenter}>
          <h5>Conecta</h5>
          <p>con personas del sector productivo desde tus inicios universitarios</p>
        </Col>
        <Col className={classes.colCenter}>
          <h5>Define</h5>
          <p>tus objetivos profesionales alineados a tu propósito</p>
        </Col>
        <Col className={classes.colCenter}>
          <h5>Desarrolla</h5>
          <p>relaciones interpersonales y mejora tu integración a un nuevo ambiente</p>
        </Col>
      </Row>

      <Row className={classes.row}>
        <Col className={classes.colCenter}>
          <h4>Conviértete en mentor</h4>
          <p>Comparte lo que te apasiona con otras personas que buscan desarrollarse en áreas similares.</p>
        </Col>
      </Row>

      <Circle size={350} width={50} top={150} left="calc(100% - 250px)"/>
      <Circle size={500} width={50} top={350} left={-400}/>
      <Circle size={30} width={8} top={450} left={300}/>
    </Container>
  );
}
export default Home;
